module.exports = __webpack_public_path__ + "static/media/GoogleSans-Medium.8d57e401.ttf";